import devConfig from './dev/config';
import prodConfig from './prod/config';
import localConfig from './local/config';

const config = import.meta.env.VITE_APP_ENV === 'prod'
    ? prodConfig
    : import.meta.env.VITE_APP_ENV === 'local'
    ? localConfig
    : devConfig;

export default {
    sentry: {
        dsn: '',
    },
    ...config,
};